// extracted by mini-css-extract-plugin
export var acceptButton = "_1t-6";
export var backdropBlur = "_1t-0";
export var fullContent = "_1t-5";
export var link = "_1t-7";
export var linkIcon = "_1t-8";
export var sideContent = "_1t-4";
export var sideImage = "_1t-3";
export var sideImageWrapper = "_1t-2";
export var splitLayout = "_1t-1";